import React from 'react'
import Button from 'orionsoft-parts/lib/components/Button'
import MdPhoneIcon from 'react-icons/lib/md/phone'
import badgeStyles from 'App/Pages/Alerts/Orders/List/Order/CallDriver/styles.css'
import copy from 'App/helpers/misc/copy'
import useMessage from 'App/hooks/useMessage'
import CopyIcon from 'react-icons/lib/md/content-copy'
import styles from './styles.css'
import useMutate from 'apollo-hooks/lib/useMutate'
import gql from 'graphql-tag'

const badgeColors = (currentCallPhoneNumber, phoneNumber) => {
  return currentCallPhoneNumber === phoneNumber ? styles.green : styles.gray
}
const badgeTooltips = (currentCallPhoneNumber, phoneNumber) => {
  return currentCallPhoneNumber === phoneNumber ? 'Finalizar llamada' : 'Iniciar llamada'
}

export default function CallClient({phone, order, currentCallPhoneNumber, makeCall, stopCall}) {
  const showMessage = useMessage()

  const mutate = useMutate()

  const logCall = async phone => {
    if (!order) return
    try {
      await mutate({
        mutation: gql`
          mutation logCall($orderId: ID, $phone: String) {
            logCall(orderId: $orderId, phone: $phone)
          }
        `,
        variables: {orderId: order._id, phone}
      })
    } catch (error) {
      alert(error.message)
    }
  }

  const onPress = value => {
    copy(value)

    showMessage(`Copiado ${phone}`)
  }

  if (!phone) return null

  const badgeTooltip = badgeTooltips(currentCallPhoneNumber, phone)

  return (
    <div className={badgeStyles.container}>
      <div className={badgeStyles.callLabel}>Llamar al cliente</div>
      <div className={styles.buttons}>
        <Button
          disabled={currentCallPhoneNumber && currentCallPhoneNumber !== phone}
          tooltip={badgeTooltip}
          onClick={() => {
            if (currentCallPhoneNumber === phone) {
              stopCall()
            } else {
              logCall(phone)
              makeCall(phone)
            }
          }}>
          <span className={badgeStyles.chat}>
            <span className={badgeStyles.label}>{phone}</span>
            <MdPhoneIcon />
          </span>
          <span
            className={`${badgeStyles.badge} ${badgeColors(currentCallPhoneNumber, phone)}`}></span>
        </Button>
        <Button onClick={() => onPress(phone)}>
          <CopyIcon />
        </Button>
      </div>
    </div>
  )
}
